export default {"src":"/_next/static/image/src/images/our-food/chia-seeds.0c9fa8a95d7ae3cc9b2922847c7c8543.svg","height":42,"width":66};